// @flow
import * as React from 'react';
import styled from 'styled-components';

import colors from '../../../assets/css/colors';
import default_image from '../../../assets/images/LeagueAvatar.svg';
import Edit from '../../../components/Icons/Edit';
import { BorderedIcon } from "../../../components";

const LeagueAvatarWrapper = styled.picture`
	img {
		height: ${({ size }) => size || '100%'};
		width: ${({ size }) => size || '100%'};
		border-radius: 50%;
		object-fit: cover;
	}
`;

const FileInput = styled.input`
	display: none;
`;

const FileLabel = styled.label`
	position: relative;
	height: ${({ size }) => size || '100%'};
	cursor: pointer;

	div {
		position: absolute;
		top: 0;
		right: 0;

		svg {
			cursor: pointer;
			font-size: 20px;
			padding: .17em;
		}
	}
`;

type Props = {
	size: string,
	name: string,
	preview_img: any,
	onChange: Function,
};

export const FormUploadImage = ({ size, name, preview_img, onChange }: Props) => {

	return (
		<FileLabel htmlFor={name} size={size}>
			<LeagueAvatarWrapper size={size}>
				<img src={preview_img ? preview_img : default_image} alt='Upload' />
			</LeagueAvatarWrapper>
			<FileInput
				type="file"
				accept=".png, .jpg, .jpeg"
				id={name}
				name={name}
				onChange={onChange}
			/>
			<BorderedIcon background='#FFFFFF' hover={colors.lightGreen}>
				<Edit />
			</BorderedIcon>
		</FileLabel>

	);
};

export default FormUploadImage;


// WEBPACK FOOTER //
// ./src/components/Form/FormUploadImage/index.js